<template>
  <div class="pagination" v-if="total != 0">
    <div class="item action" @click="backIndex">首页</div>
    <div :class="currentPage==item?'item active':'item'" v-for="item in pages" @click="jumpCurrentPage(item)">{{item}}</div>
    <div class="item action" @click="jumpNextPage">下一页</div>
  </div>
</template>

<script>
export default {
  props: ['total', 'current'],
  data() {
    return {
      showFalg: false,
      currentPage: 1,
    };
  },
  computed: {
    pages() {
      let showLen = 7
      let total = this.total
      let current = this.current
      let arr = []
      if (total <= showLen) {
        for (let i = 1; i <= total; i++) {
          arr.push(i)
        }
      } else if (total > showLen) {
        for (let i = current - 1 < 2 ? 1 : current - 2; i <= (current - 1 < 2 ? 7 : current - 2 + 7); i++) {
          arr.push(i)
        }
      }
      return arr
    }
  },
  created() {

  },
  mounted() {
    this.currentPage = this.current

  },
  watch: {
    total(val) {
      if (val > 1) {
        this.showFalg = true
      }
    },
    current(val) {
      this.currentPage = val
    }
  },
  methods: {
    backIndex() {
      this.currentPage = 1
      this.$emit('getPage', 1)
    },
    jumpCurrentPage(page) {
      this.currentPage = page
      this.$emit('getPage', page)
    },
    jumpNextPage() {
      this.currentPage = this.currentPage + 1
      this.$emit('getPage', this.currentPage)
    }
  },
  components: {

  },
};
</script>

<style scoped>
.pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2em;
}

.pagination .item {
  min-width: 1.8em;
  height: 1.8em;
  background: #fff;
  border: 1px solid #eee;
  line-height: 1.8em;
  text-align: center;
  color: #999;
  margin-right: 5px;
  cursor: pointer;
  border-radius: 3px;
}

.pagination .item.active {
  background: #4ba6ff;
  color: #fff;
}

.action {
  padding: 0 7px;
  width: 5em;
}

.pagination .item:hover {
  background: #4ba6ff;
  color: #fff;
}
</style>